import { useGetState, useSetState } from "components/ReduxProvider";
import { useTranslates } from "../../../../../hooks/useTranslates";
import { useViewerDecks } from "../../../../../queries/viewerQuery";
import { speakingStarters } from "./speakingStarters";
import { useEffectOnce } from "react-use";

export const useSpeakingStarterText = ({
  forceUpdateStarter,
  skipTranslates
}: { forceUpdateStarter?: boolean; skipTranslates?: boolean } = {}): {
  starter?: string;
  updateStarter: () => void;
} => {
  const { deck } = useViewerDecks();
  const setSpeakingStarterIndex = useSetState("speakingStarterIndex");
  const speakingStarterIndex = useGetState("speakingStarterIndex");
  const originalStarter = speakingStarterIndex !== undefined ? speakingStarters[speakingStarterIndex] : undefined;

  const updateStarter = () => {
    const newIndex = speakingStarterIndex === undefined ? 0 : (speakingStarterIndex + 1) % speakingStarters.length;
    setSpeakingStarterIndex(newIndex);
  };

  useEffectOnce(() => {
    if (speakingStarterIndex === undefined || forceUpdateStarter) {
      updateStarter();
    }
  });

  const { translates } = useTranslates(
    deck?.front || "en",
    [originalStarter || ""],
    originalStarter === undefined || skipTranslates
  );

  return { starter: translates[0], updateStarter };
};
